import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { forkJoin, Subject, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { CourseService } from "src/app/core/services/course.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
// import moment from "moment";
import { DataTableDirective } from "angular-datatables";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { CoreService } from "src/app/core/services/core/core.service";
import { TimezoneService } from "src/app/services/timezone";


@Component({
  selector: 'app-internal-merchant',
  templateUrl: './internal-merchant.component.html',
  styleUrls: ['./internal-merchant.component.scss'],
  providers: [NgbModalConfig, NgbModal,TranslatePipe],
})
export class InternalMerchantComponent implements OnInit {

    @ViewChild("ThirdPartyModel") ThirdPartyModel;
    @ViewChild("GuruHubModel") GuruHubModel;
    @ViewChild("GuruHubModel2") GuruHubModel2;
    @ViewChild("content") content;
    @ViewChild("Delete") Delete;
    TpartyButtonActive : boolean = false
    TpartyGrubButtonActive:boolean = false;
    TpartyUberButtonActive : boolean =false
    tpartymenuSetup:boolean = false;
    continuetrue:boolean = false;
    NewMenuActive:boolean = false;
    MenuName:any;
    currentmurchInfo:any={}
    MenuUrl:any=''
    dropdownSettings2 = {};
    selectedItems2 :any =[]
    dropdownList2 : any =[]
    murchandlocation:any=''

    isSignUpAllowed: boolean = false;



    breadcrumbItems: breadcrumbItem[] = [
      {
        label:'Home',
        active:false,
        url:'/home'
      },
      {
        label: 'Merchants',
        active: true,
        url: "",
        // url:"/merchants"
      },
      // {
      //   label:'Merchants-List',
      //   active:true,
      //   url: "",
      // },



    ];




    dtOptions: DataTables.Settings = { paging: true};
    // grettings: any = "Schedule";
    checkedAll: any = false;

    // colorOptions: Object = { color: "#f0b518" };
    detectChanges: boolean = true;
    value: string;
    storeId: any = "";
    GLOBALURL: string;
    // course = null;
    settings = null;

    active = 4;

    isAllModfiersFetched = false;
    params: any = new HttpParams();
    headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') }
    httpOptions = { headers: new HttpHeaders(this.headerToken) };
    httpOptions3 = {};
    selected: { id: any; text: string; currency: string; currencyCode: string; logo: string };

    limit: any;
      offset1: any;
      isEmpty: boolean = false
      isSearch: boolean = false
    options = [
      { name: 'Email', value: 'email' },
      { name: 'Mobile Number', value: 'mobileNumber' },
      { name: 'Restaurant Name', value: 'restaurantName' },
      // { name: 'Merchant Name', value: 'merchantName' },
    ];
    selectedOption: string = '';
    showInput: boolean = false;
    showButton: boolean = false;
    inputValue: string = '';
    @ViewChild(DataTableDirective, {static: false})
    datatableElement: DataTableDirective;
    dtTrigger: Subject<any> = new Subject();
    selectedMerchants: any = [];
    allMerchantsSelected: any;
    // dtOptions: DataTables.Settings = {
    //   paging: true, // Minimal default setting to avoid error
    // };
    constructor(
      private translatePipe: TranslatePipe,

      private cookieService: CookieService,
      private locService: locationBroadcastService,
      public http: HttpClient,
      private toastr: AlertService,
      public router: Router,
      public route: ActivatedRoute,
      private store: Store<AppState>,
      private modalConfig: NgbModalConfig,
      private modalService: NgbModal,
      private courseService: CourseService,
      private ApiService: ApiService,
      private BreadcrumbService: BreadcrumbService,
      private timezoneService: TimezoneService,
      private coreService: CoreService,
      private renderer: Renderer2,
    ) {
      this.GLOBALURL = this.ApiService.getBaseURL();
    }
    intialize : boolean = true;
    private dataSubscription: Subscription = null

    ngOnInit(): void {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      this.BreadcrumbService.setValue(this.breadcrumbItems);

      this.dropdownSettings2 = {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        itemsShowLimit: 3,
        allowSearchFilter: false
      };


      if (this.cookieService.get("superAdminPage") !== "3") {
        this.toastr.error('Logged-in account should be a Super Admin.')
        this.router.navigate(['/home']);
        return;
      }

      // this.dtOptions = {
      //   pageLength: 10,
      //   language: {
      //     searchPlaceholder: "Search",
      //     search: "",
      //     emptyTable: "",
      //   },
      //   // scrollY: 'calc(100vh - 510px)',
      //   // scrollCollapse: true,
      //   scrollX: true,
      //   ordering: false,
      //   dom: '<"top"f>t<"bottom"lip>'
      // };


      this.modalConfig.backdrop = "static";
      this.modalConfig.keyboard = false;
      this.params = new HttpParams();
      // this.getNumberMerchants();
      //  DATA TABLE INITIALIZATION AJAX
    this.dtOptions = {
      pageLength: 10,
        language: {
          searchPlaceholder: "Search",
          search: "",
          emptyTable: "No Merchants Available in Table",
        },
      scrollX: true,
      ordering: true,
      // order: [[0, 'desc']],
      // dom: '<"top">t<"bottom"lip>',
      dom: '<"top" f><"table-params" t><"bottom" lip>',
      paging: true,
      // searching: true,
      pagingType: 'simple_numbers',
      columnDefs: [
        { orderable: false, targets: 0 } // Disable sorting on the first column (checkbox)
     ],
      serverSide: true,
      processing: false,
      ajax: (dataTablesParameters: any, callback) => {
        //objectToHttpParams added outside ngonit
        const params: any = this.coreService.objectToHttpParams(dataTablesParameters);

        // reset http query params
        this.params = new HttpParams();

        console.log("params", dataTablesParameters)
        // find out search value
        // const search = JSON.parse(params?.updates?.find((obj) => {
        //   return obj.param === 'search';
        // })?.value)?.value
        const search = params.updates
    ? JSON.parse(params.updates.find((obj) => obj.param === 'search')?.value)?.value
    : JSON.parse(params.map.get('search')[0])?.value;

        // find out offset
        // const offset = params.updates.find((obj) => {
        //   return obj.param === 'start';
        // }).value
        let offset: any;

  if (params.updates) {
    offset = params.updates.find((obj) => obj.param === 'start').value;
  } else {
    offset = params.map.get('start')[0];
  }

        this.offset1 = offset;

        // find out limit
        // const limit = params.updates.find((obj) => {
        //   return obj.param === 'length';
        // }).value
        let limit: any;

  if (params.updates) {
    limit = params.updates.find((obj) => obj.param === 'length').value;
  } else {
    limit = params.map.get('length')[0];
  }
        this.limit = limit;

        this.value = this.cookieService.get("token");
        this.storeId = this.cookieService.get("storeId");

        // this.params = this.params.set("storeId", this.storeId);

        // Extract sorting parameters
      // const sorting = JSON.parse(params.updates.find((obj) => obj.param === 'order').value);
      let sorting;

  if (params.updates) {
    sorting = JSON.parse(params.updates.find((obj) => obj.param === 'order').value);
  } else {
    sorting = JSON.parse(params.map.get('order')[0]);
  }

      if(sorting) {
        const columnNames = [
          'merchantName',
          'merchantEmail',
          'merchantMobile',
          'storeName',
          'expirationTime'
        ];

        const sortColumnIndex = sorting[0].column;
        const sortDirection = sorting[0].dir;
        const sortColumnName = columnNames[sortColumnIndex];

        console.log("order", sorting[0])
        this.params = this.params.set("column", sortColumnName);
        this.params = this.params.set("dir", sortDirection);
      }

        // set params as per search key value
        this.params = this.params.set("limit", limit);
        this.params = this.params.set("offset", offset);
        this.params = this.params.set("status", 3);
        // if (this.inputValue !== undefined) {
        //   this.params = this.params.set("search", this.inputValue);
        // }

        // if (this.selectedOption !== undefined) {
        //   this.params = this.params.set("searchType", this.selectedOption);
        // }
        // this.params = this.params.set("showLimitedData", 1);

        if (search !== '') {
          this.params = this.params.set("search", search);
          this.isSearch = true;
          // this.store.dispatch(setLoadingSpinner({ status: false }));
        }else{
          this.isSearch = false;
        }

        // Set sorting parameters



        console.log("thissearch=8889========>",this.isSearch);

        // else {
        //   this.store.dispatch(setLoadingSpinner({ status: true }));
        // }
        this.httpOptions3 = {
          headers: new HttpHeaders(this.headerToken),
          params: this.params,
        };
        if (this.dataSubscription) {
          this.dataSubscription.unsubscribe();
        }
        // this.store.dispatch(setLoadingSpinner({ status: true }));
        this.dataSubscription = this.http
            .get(this.GLOBALURL + '/allmerchant',this.httpOptions3,
            )
            .subscribe(
              (response: any) => {
                console.log("respon========================?>>>>", response);

                this.store.dispatch(setLoadingSpinner({ status: false }));
                console.log("response.total=>NG_ONINIT", response.count, this.isSearch) ;
                if (response.count <= 0 && this.isSearch === false)
                  this.isEmpty = true;
                else this.isEmpty = false;
                callback({
                  recordsTotal: response.count,
                  recordsFiltered: response.count,
                  data: [],
                  // add one more key to store the response data
                  response: response.response,
                });
                // return (this.merchants = response.response);
                if (response.success == 0) {
                  this.toastr.clear();
                  this.toastr.error(response.message);
                  this.store.dispatch(setLoadingSpinner({ status: false }));
                } else {
                  this.intialize = false;
                  this.totalMerchants = response.response.length;
                  return this.merchants = this.processMerchants(response);
                  // this.sortByName(this.copyLicensesData, 'createdAt', false);
                }
              },
              (error) => {
                this.isEmpty = true;
                const message = this.ApiService.errorMessage(error);
                this.toastr.error(message);
                this.store.dispatch(setLoadingSpinner({ status: false }));
              }
            );
          return this.dataSubscription;
      },
      drawCallback: () => {
        if ($('.dataTables_info').length) {
          let text = $('.dataTables_info')[0]?.outerText;

          this.translatePipe.transform(text)
            .subscribe(res => {
              $('.dataTables_info').text(res);
            },
            (error) => {
              console.error("Error in translating", error);
            });
        }

        let $dataTablesLength = $('#addons-table_length.dataTables_length label');
        if ($dataTablesLength) {
          let textNode = $dataTablesLength.contents().filter(function() {
            return this.nodeType === Node.TEXT_NODE;
          });

          console.log("TEXT NODE", textNode);

          if (textNode.length > 0 && textNode.length === 2) {
            forkJoin([
              this.translatePipe.transform('Show'),
              this.translatePipe.transform('entries'),
              this.translatePipe.transform('Previous'),
              this.translatePipe.transform('Next'),
            ]).subscribe(([showTranslation, entriesTranslation, prevText, nextText]) => {
              textNode[0].nodeValue = showTranslation;
              textNode[1].nodeValue = entriesTranslation;
              let prevBtn = $('.paginate_button.previous')[0];
              let nextBtn = $('.paginate_button.next')[0];
              prevBtn ? (prevBtn.innerText = prevText) : null;
              nextBtn ? (nextBtn.innerText = nextText) : null;
            },
            (error) => {
              console.error("Error in translating", error);
            });
          }
        }

        let searchFilter = $('.dataTables_filter label input');

        this.translatePipe.transform(this.dtOptions.language.searchPlaceholder)
          .subscribe(res => {
            searchFilter ? (searchFilter.attr('placeholder', res)) : null;
            console.log(searchFilter);
          },
          (error) => {
            console.error("Error in translating", error);
          })

        if ($('.dataTables_empty')?.length && ($('.dataTables_empty')?.text() == "No matching records found")) {
          $('.dataTables_empty').hide();
        }
      }
    };

      //this.getStoresFunction();

      // check if user is allowed to visit the page
      //  if (this.cookieService.get("superAdminPage") === "3") {

      //   this.value = this.cookieService.get("token");
      //   this.storeId = this.cookieService.get("storeId");
      //   this.getNumberMerchants();
      //   this.getStoresFunction();
      // } else {
      //   this.router.navigate(["/home"]);
      // }
    }
    refreshDataTable() {
      console.log("Data table refreshed1");
      if (this.datatableElement) {

        this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
          // Reload the table data from the Ajax data source
          dtInstance.ajax.reload((json) => {
            console.log("dtinstance_FROM_AJAX", dtInstance.data(), dtInstance.page.info(), json);
            // If the response data is empty, go to the first page
            if (json.response.length === 0 && dtInstance.page.info().page > 0) {
              console.log("Data table refreshed and going to first page")
              dtInstance.page('first').draw('page');
            }
          }, false); // Pass false to keep the current paging position
          console.log("Data table refreshed");
        });
      }
    }
    processMerchants(response: any): any[] {
      const merchants = response.response;
      this.sortByName(merchants, 'createdAt', true);
      return merchants;
    }

    getHttpHeaders() {
      const headerContent = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') };
      return new HttpHeaders(headerContent);
  }


    redirect(id) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      localStorage.setItem('MID',id)
      this.router.navigate(['home']);
    }

    private dateCache = {};
    _convertDate(timeStamp: number) {
      if (timeStamp) {
          if (!this.dateCache[timeStamp]) {
              this.dateCache[timeStamp] = this.timezoneService
                  .get()(timeStamp * 1000)
                  .format("MMM D, YYYY, H:MM A");
          }
          return this.dateCache[timeStamp];
      } else {
          return "";
      }
  }



    endDate: any = this.timezoneService.get()().endOf('day');
    expirationDate: any = this.endDate.unix();
    endDateDisplayFormatted: any = this.timezoneService.get().unix(this.expirationDate).format("MMM Do YYYY");


    showClearBtn: any = false;
    searchName: any = '';
    copyLicensesData: any = [];
    locations: any = [];


    offset: any = 0;
    totalMerchants: any = 0;
    merchants: any = [];
    getNumberMerchants() {
      this.merchants = [];
      this.copyLicensesData = [];
      return this.http.get(this.GLOBALURL + '/allmerchant', this.httpOptions).subscribe((response: any) => {
        if (response.success == 0) {
          this.toastr.error(response.message);
        } else {
          this.totalMerchants = response.response.length;
          this.offset = 10;
          this.merchants = response.response
          var params = this.params.set("offset", this.offset)
          this.httpOptions2 = { headers: new HttpHeaders(this.headerToken), params: params };
          this.getMerchantsFunction();
        }
      }, (error) => {
        const message = this.ApiService.errorMessage(error)
        this.toastr.error(message);
      });
    }

    httpOptions2: any = {};
    getMerchantsFunction() {
      this.merchants = [];
      this.copyLicensesData = [];
      for (this.offset; this.offset < this.totalMerchants; this.offset += 10) {
        return this.http.get(this.GLOBALURL + '/allmerchant', this.httpOptions2).subscribe((response: any) => {
          if (response.success == 0) {
          } else {
            this.merchants = response.response
            this.sortByName(this.merchants, 'createdAt', true);
            this.sortByName(this.copyLicensesData, 'createdAt', false);
          }
        }, (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
        });
      }
    }
    clearFilter() {
      this.inputValue = '';
      this.selectedOption = '';
      this.refreshDataTable();
    }

    onOptionChange(event: any) {
      this.showInput = !!this.selectedOption;
      this.showButton = !!this.selectedOption;
    }

    filter() {
      this.refreshDataTable();
    }
    chunk(str, n) {
      var ret = [];
      var i;
      var len;
      for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    };

    // getExpirationDate(e) {
    //     console.log(e);
    // }
    toggleSelectAll(event: any): void {
      this.allMerchantsSelected = event.target.checked;
      this.merchants.forEach((merchant) => {
        merchant.selected = this.allMerchantsSelected;
        this.updateSelectedMerchants(merchant);
      });
    }

    selectMerchant(event: any, merchant: any): void {
      merchant.selected = event.target.checked;
      this.updateSelectedMerchants(merchant);
      console.log("merchant", merchant);
      this.allMerchantsSelected = this.merchants.every(m => m.selected);
      console.log("this.allMerchantsSelected", this.allMerchantsSelected);
    }

    updateSelectedMerchants(merchant: any): void {
      if (merchant.selected) {
        if (!this.selectedMerchants?.includes(merchant.merchantId)) {
          this.selectedMerchants.push(merchant.merchantId);
        }
      } else {
        this.selectedMerchants = this.selectedMerchants.filter(id => id !== merchant.merchantId);
      }
    }

    deleteSelectedMerchants() {
      if (this.selectedMerchants.length === 0) {
        this.toastr.error('Please select merchants to delete');
        return;
      }
      const payload = { merchantId: this.selectedMerchants };

      return this.http
        .post(this.GLOBALURL + "/merchantalldata", payload, {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.cookieService.get("token"),
          }),
        })
        .subscribe(
          (response: any) => {
            this.toastr.clear();
            this.toastr.success(response.message);
            this.modalService.dismissAll();
            this.refreshDataTable();

            // Clear selection
            this.selectedMerchants = [];
            this.allMerchantsSelected = false;
          },
          (error) => {
            const message = this.ApiService.errorMessage(error);
            this.toastr.clear();
            this.modalService.dismissAll();
            this.toastr.error(message);
          }
        );
    }

    deleteMerchantsmodel() {
      this.modalService.open(this.Delete, { size: "sm ", centered: true });
    }

    sortByName(arr, attr, order) {
      if (order) {
        order = false;
      } else {
        order = true;
      }
      return arr.sort((first, second) => {
        if (first[attr] > second[attr]) {
          if (order) {
            return 1;
          } else {
            return -1;
          }
        } else if (first[attr] < second[attr]) {
          if (order) {
            return -1;
          } else {
            return 1;
          }
        }
      })
    }

    itemsPP: any = 10;
    p: any = 1;
    onLimitSelected(e) {
      this.itemsPP = e;
    }

    public select(value: any) {
      this.endDate = value.end;
      this.expirationDate = this.endDate.unix();
      this.endDateDisplayFormatted = this.timezoneService.get().unix(this.expirationDate).format("MMM Do YYYY");
    }


    OpenThirdPartyModel(merchant) {
      console.log("merchant======",typeof(merchant))

     if(merchant != 'string'){
      this.getStores(merchant)
      this.currentmurchInfo = merchant
     }
      this.modalService.dismissAll();
      this.modalService.open(this.ThirdPartyModel, { size: 'lg partymodal', centered: true });

    }

    getStores(merchant) {
      console.log("====hello======",merchant.merchantId)
      const headers = this.getHttpHeaders();

      return this.http.get(
          `${this.GLOBALURL}/store?merchantId=${merchant.merchantId}`,
          { headers }
      ).pipe(
          tap( (resp: any) => {
              if (resp.success) {
                  this.locations = resp.response.map( location => ({
                      id: location.storeId,
                      name: location.storeName,
                  }) );
                  console.log(" this.locations====", this.locations)
              } else {
                  this.toastr.error(resp.message);
              }
          } )
      ).subscribe();
  }


    TpartycardActive(){
      this.TpartyButtonActive = true;
    }

    OpenGuruHubModel(){
      this.modalService.dismissAll();
      this.modalService.open(this.GuruHubModel, { size: 'lg partymodal', centered: true });
    }

    OpenGuruHubModel2(data:any){

      if (data === 'url') {
        this.tpartymenuSetup = true;
      }else{
        this.modalService.dismissAll();
        this.modalService.open(this.GuruHubModel2, { size: 'lg partymodal', centered: true });
      }

    }
    // progressbar(){
    //   this.progreessbar =true
    // }
    activebtn(event){
     if (this.MenuName === '') {
      this.continuetrue = false
     }else{
      this.continuetrue = true
     }

    }

    saveUberHurts(){
      let time =this.timezoneService.get()().unix();

      let params = {
      "url":this.MenuUrl,//"https://www.ubereats.com/store/poke-n-roll/ouUzo8JaQTqTVqOdJ71OuA",
      "menuName": this.MenuName,
      "storeId": this.murchandlocation,//"6307259668742064f9ca7ad8",
      "merchantId": this.currentmurchInfo.merchantId,//"630725966874200667ca7ad7",
      "startDate": time,
      "endDate": time
      }
      console.log("params=============",params)
      return this.http.post(this.GLOBALURL + '/menu/import/ubereats', params, this.httpOptions).subscribe(
        (response: any) => {
          console.log("response=============",response)
          if (response.success == 0) {
            this.toastr.error(response.message)
          } else {
            // this.toastr.success(response.message)
            this.toastr.success("Your menu is being retrieved from UberEats. We will send you an email once done.")
            this.modalService.dismissAll();
            // this.modalService.open(this.content, {
            //   centered: true,
            // });
          }
        },
        error => {
          this.toastr.error(error)
        }
      );
    }

    onItemSelect(item: any) {
      console.log(item);
    }
    onSelectAll(items: any) {
      console.log(items);
    }

    cancelDeleteAll(content) {
      this.modalService.dismissAll(content);

    }

    goToMerchantDetailsPage(merchant){
      this.router.navigate(['/merchants/merchant-details', merchant.merchantId]);
    }

    goToMerchantSignupPage() {
      this.router.navigate(['/merchants/merchant-signup']);
    }

    archivedMerchantId: any;
    unarchiveMerchant(id: any, content: any) {
      this.archivedMerchantId = id;
      this.modalService.open(content, {
        size: "sm unarchivedelete-modal",
        centered: true,
      });
      this.renderer.removeClass(document.body, "modal-open");
    }
    deleteMenu(id: any, content: any) {
      this.archivedMerchantId = id;
      this.modalService.open(content, {
        size: "md permanentlydelete-modal",
        centered: true,
      });
      this.renderer.removeClass(document.body, "modal-open");
    }
    unarchiveMenuFunction(content) {
      const payload = {
        merchantId: this.archivedMerchantId,
      };
      this.httpOptions3 = {
        headers: new HttpHeaders(this.headerToken),
      };
      this.detectChanges = true;
      return this.http
        .patch(this.GLOBALURL + '/merchant', payload, this.httpOptions3)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
            } else {
              this.detectChanges = true;
              this.toastr.success(response.message);
              this.modalService.dismissAll(content);
              this.checkedAll = false;
              // this.deleteBtnFlag = false;
              this.searchName = "";
              this.showClearBtn = false;
              // setTimeout(() => {
              //   this.toastr.success(response.message);
              // }, 4000);
              // this.reload();
              this.refreshDataTable();
              // this.toastr.success(response.message);

            }
          },
          (error) => {
            this.toastr.error(error?.error?.message || error?.message || error);
            this.modalService.dismissAll(content);
          }
        );
    }

    // archivedOnboardMerchantId: any;
    deleteMerchant(id: any, contentArchive: any) {
      this.archivedMerchantId = id;
      this.modalService.open(contentArchive, {
        centered: true,
      });
    }

    deleteMerchantFunction(contentArchive) {
      var params = {
        merchantId: this.archivedMerchantId,
      };
      this.httpOptions3 = {
        headers: new HttpHeaders(this.headerToken),
        params: params,
      };
      this.detectChanges = true;
      return this.http
        .delete(this.GLOBALURL + '/merchant', this.httpOptions3)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
            } else {
              this.detectChanges = true;
              this.toastr.success(response.message);
              this.modalService.dismissAll(contentArchive);
              this.checkedAll = false;
              // this.deleteBtnFlag = false;
              this.searchName = "";
              this.showClearBtn = false;
              this.reload();
            }
          },
          (error) => {
            this.toastr.error(error.error.message);
            if (error.status === 401) {
              // Handle 401 Unauthorized error
            } else {
              // Handle other errors
            }
          }
        );
    }

    reload() {
      // save current route first
      const currentRoute = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      this.router.navigate([currentRoute]);
    }

    cancelDeleteAll2(contentArchive) {
      this.modalService.dismissAll(contentArchive);

    }


    // deleteMerchantFunction(content) {
    //   const merchantIdArray = [];
    //   merchantIdArray.push(this.archivedMerchantId);
    //   // var params = {
    //   //   merchantId: [,
    //   //   // isPermanent: "1",
    //   // };
    //   const payload = { merchantId: merchantIdArray };
    //   // this.httpOptions3 = {
    //   //   headers: new HttpHeaders(this.headerToken),
    //   //   // params: params,
    //   // };
    //   this.detectChanges = true;
    //   return this.http
    //     .post(this.GLOBALURL + '/merchantalldata', payload, {
    //       headers: new HttpHeaders({
    //         "Content-Type": "application/json",
    //         Authorization: this.cookieService.get("token"),
    //       }),
    //     })
    //     .subscribe(
    //       (response: any) => {
    //         if (response.success == 0) {
    //           this.toastr.error(response.message);
    //         } else {
    //           this.detectChanges = true;
    //           this.toastr.success(response.message);
    //           this.modalService.dismissAll(content);
    //           this.checkedAll = false;
    //           // this.deleteBtnFlag = false;
    //           this.searchName = "";
    //           this.showClearBtn = false;
    //           // setTimeout(() => {
    //           //   this.toastr.success(response.message);
    //           // }, 4000);
    //           // this.reload();
    //           this.refreshDataTable();
    //         }
    //       },
    //       (error) => {
    //         this.toastr.error(error?.error?.message || error?.message || error);
    //       }
    //     );
    // }

    // Destroy the Subscriptions
    ngOnDestroy() {
      if (this.dataSubscription) {
        this.dataSubscription.unsubscribe();
      }
    }

}
